<template>
    <HamletTable
        ref="table"
        :columns="columns"
        :fetch="fetch"
        @onRowClick="onRowClick"
    >
        <template #header-label>
            {{ $t('Page(PagesSystemArticles):Component(Text):page-label') }}
        </template>
    </HamletTable>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {BButton} from 'bootstrap-vue'
import {PagesApi} from "@core/api";
import HamletTable from "@core/components/common/HamletTable";

export default {
    directives: {Ripple},
    components: {HamletTable, BButton},
    data() {
        return {
            columns: [
                {
                    key: 'id',
                    label: this.$t('Component(Grid):column-id')
                },
                {
                    key: 'systemKey',
                    label: this.$t('Component(Grid):column-system-key')
                },
            ],
        };
    },
    methods: {
        onRowClick(category) {
            this.$router.push({
                name: 'administration-pages-system-articles-edit',
                params: {
                    id: category.id
                }
            })
        },
        fetch(config, cb) {
            PagesApi.systemContent(config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        }
    }
}
</script>
